/*eslint-disable*/
export default [
    {
        path: 'homework/create',
        name: 'homework:create',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "homework" */'../../components/homework/Create.vue'),
        meta: {
            title: 'router.router_addHomework',
            prev: {
                name: 'homework:list'
            }
        },
        props ($route) {
            return {
                type: $route.params.type || 'homework',
                copy: $route.params.copy,
                page: $route.query.page
            }
        }
    },
    {
        path: 'homework/:id/edit',
        name: 'homework:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "homework" */'../../components/homework/Create.vue'),
        meta: {
            title: 'router.router_editHomework',
            prev: {
                name: 'homework:list'
            }
        },
        props ($route) {
            return {
                id: $route.params.id,
                type: $route.params.type || 'homework',
                page: $route.query.page
            }
        }
    },
    {
        path: 'homework/:id?/game/:gameId/edit/:usersIds?/:individualGeneratorSettings?',
        name: 'game:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "homework" */'../../components/homework/GameEdit.vue'),
        meta: {
            title: 'router.router_editGame',
            prev ($route) {
                let routeName = 'homework';
                if ($route.params.source === 'homework-template') {
                    routeName += '-template';
                }
                if ($route.params.id) {
                    routeName += ':edit';
                } else {
                    routeName += ':create';
                }
                return { name: routeName }
            }
        },
        props ($route) {
            return {
                id: $route.params.gameId,
                homeworkId: $route.params.id,
                usersIds: $route.params.usersIds ? $route.params.usersIds.split(',') : $route.params.usersIds,
                individualGeneratorSettings: $route.params.individualGeneratorSettings,
                source: $route.params && $route.params.source || undefined,
                courseType: $route.params && $route.params.courseType || undefined,
            }
        }
    },
];
